import { PERMISSIONS } from '@admin/config/permissions';

/** Catalog guard: CxInboxPolicy#update? (ENG-1152) — reply/send SMS and call actions. */
export const canUpdateCxInbox = () => PERMISSIONS.has('cx_inbox:update');
